import React,{Component} from 'react';

import { Alert,Button,ButtonGroup} from 'react-bootstrap';
class WorkTagView extends Component{

  constructor(props){
    super(props);
  }

  render(){
      return (
        <div>
    
        <button className={this.props.working == true ? "btnSelected": "btnWorker"}  onClick={this.props.setToWork}>
            Töihin
        </button>

        <button className={this.props.working == false ? "btnSelected": "btnWorker"}   onClick={this.props.setToOutOfWork}>
            Ulos
        </button>

        </div>
      )

  }
}
export default WorkTagView;
